"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var RadioInput = (0, mobx_react_1.observer)(function (_a) {
    var store = _a.store;
    return (react_1.default.createElement(react_1.default.Fragment, null, store.optionStores.map(function (option, idx) { return (react_1.default.createElement("label", { key: idx, className: "estimateForm-RadioInput_Label" },
        react_1.default.createElement("input", { type: "radio", name: store.name, value: option.value, checked: store.value === option.value, onChange: store.handleChange, onBlur: store.handleBlur, className: "estimateForm-RadioInput" }),
        react_1.default.createElement("span", { className: "estimateForm-RadioInput_LabelText" }, option.label))); })));
});
exports.default = RadioInput;
